import { render, staticRenderFns } from "./TaxonomyLevelsEditWarningModal.vue?vue&type=template&id=2c5a5536&scoped=true&"
import script from "./TaxonomyLevelsEditWarningModal.vue?vue&type=script&lang=js&"
export * from "./TaxonomyLevelsEditWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyLevelsEditWarningModal.vue?vue&type=style&index=0&id=2c5a5536&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a5536",
  null
  
)

export default component.exports